import React, { useEffect, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addNewMappingReport, getAllRolesReport } from "../api/report";

const AddRolesReport = () => {
  const [formData, setFormData] = useState({
    role_id: "",
    report_types: "",
  });
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [reports, setReports] = useState([]);

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("role_id", formData.role_id);
    payload.append("report_types", formData.report_types);

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([role_id]) => role_id);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }

      const response = await addNewMappingReport(payload);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.REPORT);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to submit data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Server error while submitting data",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach(err => toast.error(err.msg,{
              autoClose: false,
              closeOnClick: true,
              draggable: true,
            }));
          } else {
            toast.error(detail?.msg || detail || "An unexpected error occurred.",{
              autoClose: false,
              closeOnClick: true,
              draggable: true,
            });
          }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchMappings = async () => {
      try {
        const res = await getAllRolesReport();
        if (!res) {
          toast.error("No data received or malformed response");
          console.warn("No data received or malformed response:", res);
          return;
        }
        setReports(res.data.reports || []);
      } catch (error: any) {
        console.error("Failed to fetch employee data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach(err => toast.error(err.msg));
          } else {
            toast.error(detail?.msg || detail || "An unexpected error occurred.");
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMappings();
  }, []);

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Add  Report</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Report Types *</label>
          <input
            type="text"
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            className={getInputClass("role_id")}
            placeholder="Role Id"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Report Types *</label>
          <select
            name="report_types"
            value={formData.report_types}
            onChange={handleChange}
            className={getInputClass("report_types")}
          >
            <option value="">Select Report Type</option>
            {reports.map((report) => (
              <option key={report} value={report}>
                {report}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Add Report {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default AddRolesReport;
